import { render, staticRenderFns } from "./DeferredOssUploader.vue?vue&type=template&id=63227de3&scoped=true&"
import script from "./DeferredOssUploader.vue?vue&type=script&lang=js&"
export * from "./DeferredOssUploader.vue?vue&type=script&lang=js&"
import style0 from "./DeferredOssUploader.vue?vue&type=style&index=0&id=63227de3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63227de3",
  null
  
)

export default component.exports